import { useReducer } from 'react';
import { IMmv } from './types';
import { ACTIONS } from './actions';
import { fetchMmvData } from './api';

export const useMmvData = () => {
    const [state, dispatch] = useReducer(reducer, {
        isFetching: null,
        isSuccess: null,
        isError: null,
        mmvData: {},
    });

    const getMmvData = async ({ vehicle_type }) => {
        try {
            const data = await fetchMmvData({ vehicle_type });
            dispatch({
                type: ACTIONS.SET_MMV_DATA,
                payload: data?.result,
            });
        } catch (e: unknown) {
            const status =
                e instanceof Error &&
                'status' in e &&
                typeof e.status === 'number'
                    ? e.status
                    : undefined;
            console.error('Unable to fetch MMV data', {
                status,
                error: e,
            });
            dispatch({
                type: ACTIONS.SET_MMV_ERROR,
                payload: {
                    status,
                },
            });
        }
    };

    function reducer(state: IMmv, action) {
        if (action.type === ACTIONS.GET_MMV_DATA) {
            getMmvData({ vehicle_type: action?.payload?.vehicle_type });
            return {
                ...state,
                isFetching: true,
                isSuccess: false,
                isError: false,
            };
        }
        if (action.type === ACTIONS.SET_MMV_DATA) {
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                isError: false,
                mmvData: {
                    ...action.payload,
                },
            };
        }
        if (action.type === ACTIONS.SET_MMV_ERROR) {
            return {
                ...state,
                isFetching: false,
                isSuccess: false,
                isError: true,
                mmvData: {},
            };
        }
        return {
            ...state,
        };
    }

    return {
        mmvStore: state!,
        dispatch,
    };
};
